import React, { useState, useEffect } from 'react'
import { Layout, Modal, Button, Row, Col, Typography, Image } from 'antd'
import ChadBookingShortcuts from './components/ChadBookingShortcuts'
import ManageHealth from './components/ManageHealth'
import ChadHealthHacks from './components/ChadHealthHacks'
import ChadTrending from './components/ChadTrending'
import ChadSubscriptions from './components/ChadSubscriptions'
import chadImage from '../../../../../assets/Mobile app/Chad.jpg'

const { Content } = Layout
const { Title, Paragraph } = Typography

const ChadDashboardWrapper = () => {
  const [showIntroModal, setShowIntroModal] = useState(false)

  // Show intro modal when component mounts
  useEffect(() => {
    setShowIntroModal(true)
  }, [])

  return (
    <Layout style={{ background: '#f0f2f5', minHeight: '100vh' }}>
      <Content style={{ paddingBottom: '70px' }}>
        <div style={{ maxWidth: '100%', margin: '0 auto' }}>
          <Row gutter={[0, 4]}>
            <Col span={24} style={{ padding: '16px 16px 0' }}>
              <ChadBookingShortcuts />
            </Col>
            <Col span={24} style={{ padding: '0 16px', marginTop: '12px' }}>
              <ManageHealth />
            </Col>
            <Col span={24} style={{ padding: '0 16px', marginTop: '4px' }}>
              <ChadSubscriptions />
            </Col>
            <Col span={24} style={{ padding: '0 16px', marginTop: '-4px' }}>
              <ChadHealthHacks />
            </Col>
            <Col span={24} style={{ padding: '0 16px', marginTop: '4px' }}>
              <ChadTrending />
            </Col>
          </Row>
        </div>
      </Content>

      <Modal
        open={showIntroModal}
        onCancel={() => setShowIntroModal(false)}
        footer={[
          <Button
            key='submit'
            type='primary'
            onClick={() => setShowIntroModal(false)}
            style={{ background: '#0066ff', borderColor: '#0066ff' }}
          >
            Join Chad's Journey
          </Button>
        ]}
        width={320}
        centered
        title={null}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <div style={{ width: '100%', marginBottom: '16px', borderRadius: '8px', overflow: 'hidden' }}>
            <Image src={chadImage} alt='Chad Le Clos' preview={false} style={{ width: '100%' }} />
          </div>
          <Title level={3} style={{ marginBottom: '8px', fontSize: '24px', fontWeight: 'bold' }}>
            Simply Unbelievable!
          </Title>
          <Paragraph style={{ fontSize: '16px', color: '#333' }}>
            We're thrilled to announce that Olympic Gold Medalist Chad Le Clos has joined Meta-Health! Gain exclusive
            access to Chad's training routines, nutrition plans, and health advice directly through our platform.
          </Paragraph>
        </div>
      </Modal>
    </Layout>
  )
}

export default ChadDashboardWrapper
